import { combineReducers } from 'redux';

import addendumFile from './addendumFile';

export default combineReducers({
  addendumFile,
});
